module.exports = __webpack_public_path__ + "img/speak_icn.png.4b62942c.svg";